import { useLocation } from 'react-router-dom';

export default () => {
  const { pathname } = useLocation();
  return !(pathname.startsWith('/new_lms/manage') || pathname.startsWith('/learner'));
};
